import React from "react";
import CustomButton from "./CustomButton";
const CustomLink = (props) => {
  return <CustomButton {...props } link={true} />;
};
export default CustomLink;
